import { createTheme } from '../stitches.config';

export const SwedishTheme = createTheme({
  fonts: {
    regular: '"Swiss721 BT Condensed Roman", sans-serif',
		keyboardFont: '$regular',
		bold: '"Swiss721 BT Condensed", sans-serif',
		semiBold: '$bold',
		medium: '"Helvetica LT Std", sans-serif',
		clue: '$regular',
    primary: '$regular',
  },
});
